"use client";
import styled from "../../../client-utils/styled/index.js";
import { DOUBLE, TRIPLE, QUADRUPLE, SEPTENDECUPLE } from "../../../constants/numbers.consts.js";
import { NAVIGATION_RAIL_DRAWERWIDTH } from "../../../constants/navigationRail.consts.js";
import PopupMenu from "../../../components/molecules/PopupMenu/index.js";
import Box from "../../../components/atoms/Box/index.js";
import SkeletonAtom from "../../../components/atoms/Skeleton/index.js";
import Typography from "../../../components/atoms/Typography/index.js";
import CardButtonAtom from "../../../components/atoms/CardButton/index.js";
const coreComponentName = "SdbAppSwitcherMenu";
export const Root = styled(PopupMenu, { name: coreComponentName, slot: "Root" })(({ theme }) => ({
    [theme.breakpoints.down("expanded")]: {
        paddingBottom: 0,
    },
}));
export const Header = styled(Box, {
    name: coreComponentName,
    slot: "Header",
})(({ theme }) => ({
    minHeight: theme.spacing(SEPTENDECUPLE),
}));
export const HeaderInner = styled(Box, {
    name: coreComponentName,
    slot: "HeaderInner",
})(({ theme }) => ({
    position: "relative",
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: theme.spacing(TRIPLE),
    marginLeft: `${NAVIGATION_RAIL_DRAWERWIDTH}px`,
}));
export const HeaderTitle = styled(Typography, {
    name: coreComponentName,
    slot: "HeaderTitle",
})();
export const Main = styled(Box, {
    name: coreComponentName,
    slot: "Main",
})();
export const CardButton = styled(CardButtonAtom, {
    name: coreComponentName,
    slot: "CardButton",
})(({ theme }) => ({
    marginBottom: theme.spacing(DOUBLE),
    "&:last-of-type": {
        marginBottom: 0,
    },
}));
export const CardContent = styled(Box, {
    name: coreComponentName,
    slot: "CardContent",
})(({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: theme.spacing(QUADRUPLE),
}));
export const Skeleton = styled(SkeletonAtom, {
    name: coreComponentName,
    slot: "Skeleton",
})({ minHeight: 72 });
export const Footer = styled(Box, {
    name: coreComponentName,
    slot: "Footer",
})(({ theme }) => ({
    [theme.breakpoints.down("expanded")]: {
        borderTopColor: "transparent",
    },
    "@media (hover: none) and (pointer: coarse)": {
        display: "none",
    },
}));
export const FooterInner = styled(Box, {
    name: coreComponentName,
    slot: "FooterInner",
})({
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
});
